import { type SemanticColorName } from '@kizen/kds/Colors';
import { type ValidIcons } from '@kizen/kds/Icon';
import type { HistoryStatus } from 'pages/AutomationEngine/types';
import { type TFunction } from 'react-i18next';

export const HISTORY_STATUS_CONFIG: Record<
  HistoryStatus | 'running',
  {
    color: SemanticColorName;
    label: (t: TFunction) => string;
    icon: ValidIcons;
  }
> = {
  running: {
    color: 'feedback-info-foreground',
    label: (t) => t('Running'),
    icon: 'status-running',
  },
  completed: {
    color: 'feedback-success-foreground',
    label: (t) => t('Completed'),
    icon: 'status-completed',
  },
  debug_waiting: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Debug Waiting'),
    icon: 'status-debug-waiting',
  },
  failed: {
    color: 'feedback-error-foreground',
    label: (t) => t('Failed'),
    icon: 'status-failed',
  },
  paused_by_failure: {
    color: 'feedback-error-foreground',
    label: (t) => t('Paused by Failure'),
    icon: 'status-paused-by-failure',
  },
  pending: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Pending'),
    icon: 'status-pending',
  },
  pending_throttled: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Pending (Throttled)'),
    icon: 'status-pending-throttled',
  },
  pending_retry: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Pending (Retry)'),
    icon: 'status-pending-retry',
  },
  paused_before_execution: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Paused'),
    icon: 'status-paused-before-execution',
  },
  skipped_execution: {
    color: 'feedback-success-foreground',
    label: (t) => t('Skipped Execution'),
    icon: 'status-skipped-execution',
  },
  paused_after_execution: {
    color: 'feedback-success-foreground',
    label: (t) => t('Paused After Execution'),
    icon: 'status-paused-after-execution',
  },
  cancelled: {
    color: 'font-primary',
    label: (t) => t('Cancelled'),
    icon: 'status-cancelled',
  },
  waiting_for_branches: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Waiting for Branches'),
    icon: 'status-waiting-for-branches',
  },
  blocked: {
    color: 'feedback-warning-foreground',
    label: (t) => t('Waiting for Loop'),
    icon: 'status-blocked',
  },
};
